import type { FaireProductEntity } from "../../entity_types/product";

export const p_acvsk4nwej: FaireProductEntity = {
  token: "p_acvsk4nwej",
  type: "product",
  name: "Kids Magical Princess Beauty Makeup Kit - 6 Pcs",
  brandToken: "b_1e67dn411w",
  brandName: "Cap Zone",
  imageUrl:
    "https://cdn.faire.com/fastly/42cbc7723f9c5802bc26fd83aa1a9917c2fd62c57d3fac4c455164938a70be8e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d76e18e3df5661bd851f32fca141a21a4c0c7074172423e0cc985026f5b5f55.jpeg",
    "https://cdn.faire.com/fastly/6c93726708e9d2627731e5cc9c2ae17533f211782cd66a319378a545cd5349c7.jpeg",
    "https://cdn.faire.com/fastly/6f9e90ae8e4afb7ac3f90d24626edc7e819e808190cb36d4b4faca0e055a03ae.jpeg",
    "https://cdn.faire.com/fastly/3a390972184d3acd57d714ee51a52ba4393cf68cac8b88d8a75ef6780371660f.jpeg",
    "https://cdn.faire.com/fastly/38261a4bf40963bffb7e73b00533f718d92614466399d4951eda5ddcb9872508.jpeg",
    "https://cdn.faire.com/fastly/7c35879dcac5accef5c445fa1fd84c89e65163c6390e08b2971c1ab421afe165.jpeg",
    "https://cdn.faire.com/fastly/c7a7c63b6d5c8adc01734a9dc3c4ef3069953b4a8352e58a28a93a8c020db352.jpeg",
    "https://cdn.faire.com/fastly/b3e940ac47ec1ee3e25d29c1e55c06c8a09927a5751a549343c731b2484f7b8e.jpeg",
    "https://cdn.faire.com/fastly/2b0ccc1965932ccc49ded88a24b1c1ce68066c9cddebc88f4fb022944d7b91b8.jpeg",
  ],
  priceDollars: 3.5,
  description:
    'Kids Magical Princess Purse Case Beauty Collection Manicure Pedicure Makeup Kit - 6 pcs\r\n\r\n-Item Dimensions: 5.75" * 2" * 6.25"\r\n-Display Box Dimensions: 13.25" * 9.25" * 7"\r\n-Assorted Color (6 - 3 Units Per Set, May Vary)\r\n-CA Prop 65 Advisory\r\n\r\nSet Contains: \r\n-1 x 11-Color Glitter Eyeshadow Highlighter Blusher Palette OR 8-Color Glitter Eyeshadow Highlighter Blusher Palette\r\n-4 x Lipstick OR 2 x Nail Polish and 1 x Toe Separator\r\n-1 x Dual Ended Eyeshadow Applicator\r\n-1 x Mini Makeup Brush\r\n\r\n-Packaging Details: Packed as whole in carton display box.',
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:22.487Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
